export default class EnxUtils {
  static getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  static async openMediaDevices(constraints) {
    return await navigator.mediaDevices.getUserMedia(constraints);
  }

  static async createRoom(url) {
    const username = "demo";
    const password = "enablex";
    const response = await fetch(`${url}/createRoom/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic " + btoa(username + ":" + password),
      },
    });
    return response.json();
  }

  static async createToken(data, url) {
    const response = await fetch(`${url}/createToken/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }

  static plotVideo(streamObj, id) {
    let node = document.createElement("video");
    node.srcObject = streamObj.stream;
    node.autoplay = true;
    node.setAttribute("id", streamObj.streamID);
    node.setAttribute("width", "100%");
    node.setAttribute("height", "100%");
    document.getElementById(id).appendChild(node);
  }

  static loadScript(url) {
    return new Promise(resolve => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      if (script.readyState) {  //IE
        script.onreadystatechange = function () {
          if (script.readyState === "loaded" || script.readyState === "complete") {
            script.onreadystatechange = null;
            resolve();
          }
        };
      } else {  //Others
        script.onload = function () {
          resolve();
        };
      }
      script.src = url;
      document.getElementsByTagName("head")[0].appendChild(script);
    });
  }

  static downloadAiSDK() {
    if (EnxUtils.p == null) {
      EnxUtils.p = EnxUtils.loadScript("https://sdk.ai-supply.online/mphtools/v1.0/mphtools.js")
        .then(() => EnxUtils.loadScript("https://ai-sdk.ai-supply.online/v1.14/ai-sdk.js"))
        .then(() => CY); // CY is a global var
    }
    return EnxUtils.p;
  }
}
